import { CloseButton, Group, Modal, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./FeedbackModal.module.css";

/**
 * AD-188: a centred message in a modal — an icon in a round tile, a title, a line of
 * text and the buttons under them. Used for the change-password confirmation and the
 * "password changed" and "invitation sent" confirmations.
 *
 * `tone` picks the tile colour: "pink" for a question, "green" for a done message.
 */
export const FeedbackModal = ({ opened, onClose, icon, tone = "pink", title, children, actions, paddingX = 32 }) => {

    const { t } = useTranslation();

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            centered
            withCloseButton={false}
            size="min(440px, 95vw)"
            radius={16}
            padding={0}
            classNames={{ content: classes.content, inner: classes.inner }}
        >
            <CloseButton
                onClick={onClose}
                size="lg"
                pos="absolute"
                top={9}
                right={9}
                aria-label={t('common.close')}
            />
            <Stack gap={20} align="stretch" px={paddingX} py={40} className={classes.body}>
                <Stack gap={16} align="center">
                    <div className={`${classes.tile} ${classes[tone] || classes.pink}`}>
                        {icon}
                    </div>
                    <Stack gap={4} align="center">
                        <Text className={classes.title} ta="center">{title}</Text>
                        {children && <Text className={classes.text} ta="center">{children}</Text>}
                    </Stack>
                </Stack>
                {actions && <Group gap={12} justify="center" wrap="nowrap" className={classes.actions}>{actions}</Group>}
            </Stack>
        </Modal>
    );
};
